
import AxiosApiClient from './AxiosApiClient';
import AuthUtility from '../frontend/auth/AuthUtility';

import $ from 'jquery'; // Import jQuery

const error_style = 'font-source-sans font-small font-weight-500 txt-000 bg-light-red p-5';

const initialUserInput = {
    first_name: '',
    last_name: '',
    email: '',
    app: process.env.REACT_APP_NAME,
    errorList: [],
    errorStyle: [],
};

// helper for API backend selection
const getAuthApi = () => {
    return localStorage.getItem('auth_api') && localStorage.getItem('auth_api') !== ''
        ? localStorage.getItem('auth_api')
        : 'phpLaravel';
};

export const UserService = (event, { userInput, setUserInput, setViewMode, setIsLoading, navHistory, swal }) => {
    if (event) event.preventDefault();

    setIsLoading(true);

    // Create FormData instance
    const formData = new FormData();

    appendIfNotNull(formData, 'first_name', userInput.first_name);
    appendIfNotNull(formData, 'last_name', userInput.last_name);
    appendIfNotNull(formData, 'email', userInput.email);
    appendIfNotNull(formData, 'app', userInput.app);
    formData.append('mode', 'edit');

    const fetchApiDataSaveUser = async () => {
        try {
            const { getBearerToken, makeRequestWithHeaders } = AxiosApiClient({
                apiBackend: getAuthApi(),
                token: localStorage.getItem('auth_token'),
            });

            await getBearerToken();
            const response = await makeRequestWithHeaders('post', '/api/save_user', formData, {
                params: {
                    'Authorization': `Bearer ${localStorage.getItem('auth_token')}`,
                },
            });

            setApiDataSaveUser(response, "UserService", { userInput, setUserInput, setViewMode, setIsLoading, navHistory, swal });
        } catch (error) {
            handleApiErrorSaveUser(error, "UserService", { setViewMode, setIsLoading, navHistory, swal });
        }
    };

    fetchApiDataSaveUser();
};

function setApiDataSaveUser(response, theFunction, { userInput, setUserInput, setViewMode, setIsLoading, navHistory, swal }) {
    if (response && response.data) {
        if (response.data.status === 200) {//HTTP_OK
            console.log(theFunction + ': ', response.data.message);

            AuthUtility.setUserData(response.data.first_name, response.data.last_name, response.data.email);

            setUserInput(initialUserInput);

            setViewMode('view_account');
            swal("Info", response.data.message, "info");
        } else if (response.data.status === 401) {//HTTP_UNAUTHORIZED
            console.log(theFunction + ' error: ', response.data.message + ' back-end api call error');

            //user not authenticated on server so remove from local storage
            AuthUtility.clearAuthData();
            AuthUtility.clearOrganizationData();
            
            setIsLoading(false);
            navHistory('/login');
        } else if (response.data.status === 404) {//HTTP_NOT_FOUND
            console.log(theFunction + ' error: ', response.data.message + ' back-end api call error');

            setIsLoading(false);
            swal("Warning", response.data.message, "warning");
        } else if (response.data.status === 422) {//HTTP_UNPROCESSABLE_ENTITY
            console.log(theFunction + ' error: ', response.data.message + ' back-end api call error');

            setIsLoading(false);
            swal("Warning", response.data.message, "warning");
        } else if (response.data.status === 800) {//HTTP_FORM_VALIDATION_FAILED
            console.log(theFunction + ': ', response.data.message + ' HTTP_FORM_VALIDATION_FAILED');

            var errorStyleTemp = JSON.parse(JSON.stringify(response.data.validation_errors));
            Object.keys(errorStyleTemp).map((key) => (
                errorStyleTemp[key] = error_style
            ));
            Object.keys(errorStyleTemp).map((key) => (
                $('#' + key + '_message').addClass('hide') //clear any previous message
            ));

            //validation errors mapped to input fields
            setUserInput({ ...userInput, errorList: response.data.validation_errors, errorStyle: errorStyleTemp });
        } else {//more errors
        }
    }

    setIsLoading(false);
}

function handleApiErrorSaveUser(error, theFunction, { setIsLoading, navHistory, swal }) {
    console.log(theFunction + ' error: ', error + ' back-end api call error');

    AuthUtility.clearAuthData();
    AuthUtility.clearOrganizationData();

    setIsLoading(false);
    swal("Error", error.toString(), "error");
    navHistory('/login');
}

// Helper function
const appendIfNotNull = (formData, key, value) => {
    if (value !== null && value !== undefined && value !== "null") {
        formData.append(key, value);
    } else {
        formData.append(key, ''); // or skip if your backend interprets missing fields as null
    }
};